import {
    ACTIVITY,
    ACTIVITY_SUCCESS,
    ACTIVITY_ERROR,
    ACTIVITY_DETAIL,
    ACTIVITY_DETAIL_SUCCESS,
    ACTIVITY_DETAIL_ERROR,
    CALENDAR_ACTIVITY,
    CALENDAR_ACTIVITY_SUCCESS,
    CALENDAR_ACTIVITY_ERROR,
    ADD_ACTIVITY,
    ADD_ACTIVITY_SUCCESS,
    ADD_ACTIVITY_ERROR,
    UPDATE_ACTIVITY,
    UPDATE_ACTIVITY_SUCCESS,
    UPDATE_ACTIVITY_ERROR,
    DELETE_ACTIVITY,
    DELETE_ACTIVITY_ERROR,
    DELETE_ACTIVITY_SUCCESS,
    DELETE_ACTIVITIES,
    DELETE_ACTIVITIES_ERROR,
    DELETE_ACTIVITIES_SUCCESS,
    DELETE_ALL_ACTIVITIES_SUCCESS,
    ADD_DETAILS_IMAGE,
    ADD_DETAILS_IMAGE_ERROR,
    ADD_DETAILS_IMAGE_SUCCESS,
    ADD_THUMBNAIL_IMAGE,
    ADD_THUMBNAIL_IMAGE_ERROR,
    ADD_THUMBNAIL_IMAGE_SUCCESS,
    DELETE_RECURRENCE_ACTIVITY,
    DELETE_RECURRENCE_ACTIVITY_ERROR,
    DELETE_RECURRENCE_ACTIVITY_SUCCESS,
    GET_ACTIVITIES_IMAGES,
    GET_ACTIVITIES_IMAGES_ERROR,
    GET_ACTIVITIES_IMAGES_SUCCESS,
    ACTIVITY_TAGS,
    ACTIVITY_TAGS_ERROR,
    ACTIVITY_TAGS_SUCCESS,
    ACTIVITY_FILTERS,
    ACTIVITY_FILTERS_ERROR,
    ACTIVITY_FILTERS_SUCCESS
} from "../constants/activitiesConstants";


const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: '',
    tags: []
};


export function activityReducer(state = initialState, action) {

    switch (action.type) {
        case ACTIVITY:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ACTIVITY',
                'loadingMessage': 'THE ACTIVITIES ARE BEING LOADED',
                'type': action.type

            });
        case ACTIVITY_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case ACTIVITY_SUCCESS:
            const communityIdNewActivities = (action && action.communityId) ? action.communityId : '';

            let oldData = (state && state.activityData && state.activityData.data && state.activityData.data.length > 0) ? state.activityData.data : [];
            const communityIdInOldData = (oldData && oldData[0] && oldData[0].communityId) ? oldData[0].communityId : '';

            if (state.activityData && communityIdNewActivities === communityIdInOldData && action.currentPage > 0) {
                const oldActivities = oldData.filter(activity => !action.data.data.some(newIssue => newIssue._id === activity._id));

                let activtiySorting = action.data ? action.data.data : [];

                activtiySorting.sort((a, b) => {

                    if (new Date(a.date) > new Date(b.date)) {
                        return 1;
                    } else {
                        return -1;
                    }
                });

                action.data.data = oldActivities.concat(activtiySorting);
            } else {
                action.data.data.sort((a, b) => {

                    if (new Date(a.date) > new Date(b.date)) {
                        return 1;
                    } else {
                        return -1;
                    }
                });
            }

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'activityData': action.data,
                'type': action.type

            });
        case ACTIVITY_DETAIL:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ACTIVITY',
                'loadingMessage': 'THE ACTIVITY DETAIL IS BEING LOADED',
                'type': action.type,

            });
        case ACTIVITY_DETAIL_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case ACTIVITY_DETAIL_SUCCESS:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'activityDetail': action.data,
                'type': action.type
            });
        case CALENDAR_ACTIVITY:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'CALENDAR',
                'loadingMessage': 'THE CALENDAR IS BEING LOADED',
                'type': action.type

            });
        case CALENDAR_ACTIVITY_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case CALENDAR_ACTIVITY_SUCCESS:
            let calendarActivityData = action.data ? action.data : [];
            calendarActivityData.sort((a, b) => {

                if (new Date(a.date) > new Date(b.date)) {
                    return 1;
                } else {
                    return -1;
                }
            });

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'calendarActivityData': calendarActivityData,
                'type': action.type

            });
        case ADD_ACTIVITY:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ACTIVITY',
                'loadingMessage': 'THE ACTIVITY IS BEING SAVED',
                'type': action.type
            });
        case ADD_ACTIVITY_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case ADD_ACTIVITY_SUCCESS:
            let addActivityData = state.activityData ? [...state.activityData.data] : []

            addActivityData.sort((a, b) => {

                if (new Date(a.date) > new Date(b.date)) {
                    return 1;
                } else {
                    return -1;
                }
            });

            action.data.data = addActivityData;

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'activityData': action.data,
                'type': action.type
            });

        case UPDATE_ACTIVITY:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ACTIVITY',
                'loadingMessage': 'THE ACTIVITY IS BEING UPDATED',
                'type': action.type
            });
        case UPDATE_ACTIVITY_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case UPDATE_ACTIVITY_SUCCESS:

            let updActivityData = state.activityData ? state.activityData.data : []

            updActivityData = updActivityData.map((item) => { return item._id === action.data._id ? action.data : item });

            action.data.data = updActivityData;

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'activityData': action.data,
                'type': action.type
            });
        case DELETE_ACTIVITY:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ACTIVITY',
                'loadingMessage': 'THE ACTIVITY IS BEING DELETED',
                'type': action.type
            });
        case DELETE_ACTIVITY_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DELETE_ACTIVITY_SUCCESS:

            let deleteArray = state.activityData ? state.activityData.data : [];

            deleteArray = deleteArray.filter(item => item._id !== action.data._id);

            action.data.data = deleteArray;

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'activityData': action.data,
                'type': action.type
            });
        case DELETE_ACTIVITIES:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ACTIVITY',
                'loadingMessage': 'THE ACTIVITIES ARE BEING DELETED',
                'type': action.type
            });
        case DELETE_ACTIVITIES_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DELETE_ACTIVITIES_SUCCESS:

            let deleteMultipleArray = state.activityData ? state.activityData.data : [];
            let activitiesDeleted =  action.data.toString().split(',');
            activitiesDeleted.forEach(activity => {
                deleteMultipleArray = deleteMultipleArray.filter(item => item._id !== activity);
            });

            action.data = deleteMultipleArray;

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'activityData': action.data,
                'type': action.type
            });

        case DELETE_ALL_ACTIVITIES_SUCCESS:
            action.data.data = [];

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'activityData': action.data,
                'type': action.type
            });
        case DELETE_RECURRENCE_ACTIVITY:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ACTIVITY',
                'loadingMessage': 'THE ACTIVITY IS BEING DELETED',
                'type': action.type
            });
        case DELETE_RECURRENCE_ACTIVITY_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DELETE_RECURRENCE_ACTIVITY_SUCCESS:
            let arr = state.activityData ? state.activityData.data : [];

            arr = arr.filter(item => item.scheduleId !== action.data.scheduleId);

            action.data.data = arr;

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'activityData': arr,
                'type': action.type
            });

        case ADD_DETAILS_IMAGE:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'detailsImageData': '',
                'type': action.type
            });
        case ADD_DETAILS_IMAGE_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': action.data,
                'detailsImageData': '',
                'type': action.type
            });
        case ADD_DETAILS_IMAGE_SUCCESS:
            const detailsActionData = action.data.url;
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'detailsImageData': detailsActionData,
                'type': action.type
            });
        case ADD_THUMBNAIL_IMAGE:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'thumbnailImageData': '',
                'type': action.type
            });
        case ADD_THUMBNAIL_IMAGE_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': action.data,
                'thumbnailImageData': '',
                'type': action.type
            });
        case ADD_THUMBNAIL_IMAGE_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'thumbnailImageData': action.data,
                'type': action.type
            });
        case GET_ACTIVITIES_IMAGES:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ACTIVITY',
                'loadingMessage': 'THE ACTIVITIES IMAGES ARE BEING LOADED',
                'type': action.type
            });
        case GET_ACTIVITIES_IMAGES_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case GET_ACTIVITIES_IMAGES_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'type': action.type,
                'activitiesImages': action.data

            });
        case ACTIVITY_TAGS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ACTIVITY',
                'loadingMessage': 'THE ACTIVITIES TAGS ARE BEING LOADED',
                'type': action.type
            });
        case ACTIVITY_TAGS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case ACTIVITY_TAGS_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'type': action.type,
                'tags': action.data

            });

        case ACTIVITY_FILTERS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ACTIVITY',
                'loadingMessage': 'THE FILTERS ARE BEING APPLIED',
                'type': action.type
            });
        case ACTIVITY_FILTERS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });

        case ACTIVITY_FILTERS_SUCCESS:

            const commIdNewAct = (action && action.communityId) ? action.communityId : '';

            let filtersOldData = (state && state.activityData && state.activityData.data && state.activityData.data.length > 0) ? state.activityData.data : [];
            const commIdInOldData = (filtersOldData && filtersOldData[0] && filtersOldData[0].communityId) ? filtersOldData[0].communityId : '';

            if (state.activityData && commIdNewAct === commIdInOldData && action.currentPage > 0) {
                const oldActivities = filtersOldData.filter(activity => !action.data.data.some(newIssue => newIssue._id === activity._id));

                let activtiySorting = action.data ? action.data.data : [];

                action.data.data = oldActivities.concat(activtiySorting);
            }

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'activityData': action.data,
                'type': action.type

            });
        default:
            return state;
    }
};

export default activityReducer